import * as Yup from "yup";
import RootCauseAnalysis from "./steps/rootCauseAnalysis";

export interface ChangeIdeaType {
  label: string;
  value: string;
  isSelected: boolean;
}

export interface TeamMembers {
  fullName: string;
  role: string;
}

const ProjectInformationSchema = Yup.object().shape({
  name: Yup.string().required("Project name is required."),
  sponsor: Yup.string().required("Sponsor is required."),
  specialtyDepartment: Yup.string().required(
    "Specialty Department is required"
  ),
  startDate: Yup.string().required("Start Date is required."),
  lastRevised: Yup.string().required("Last revised date is required."),
});

export const projectInformation = {
  validateOnChange: true,
  validateOnBlur: true,
  initialValues: {
    teamMembers: [
      {
        fullName: "",
        role: "",
      },
    ],
    name: "",
    sponsor: "",
    specialtyDepartment: "",
    subSpecialtyDepartment: "",
    department: "",
    startDate: "",
    lastRevised: "",
  },
  validationSchema: ProjectInformationSchema,
};

const ProblemStatementSchema = Yup.object().shape({
  problem: Yup.string().required("Please enter the problem."),
  magnitude: Yup.string().required(
    "Please enter the magnitude of the problem."
  ),
  unitOfMeasure: Yup.string().required("Please enter the unit of measure."),
  whereDoesTheProblemExist: Yup.string().required(
    "Please identify where does the problem exist."
  ),
  from: Yup.string().required("Required!"),
  to: Yup.string().required("Required!"),
  effect: Yup.string().required(
    "Please enter the effect caused by this problem!"
  ),
});

export const problemStatement = {
  validateOnChange: true,
  validateOnBlur: true,
  initialValues: {
    problem: "",
    magnitude: "",
    unitOfMeasure: "",
    whereDoesTheProblemExist: "",
    from: "",
    to: "",
    effect: "",
    problemStatement: "",
  },
  validationSchema: ProblemStatementSchema,
};

const AimStatementSchema = Yup.object().shape({
  qitName: Yup.string().required("Please enter the QIT name."),
  aim: Yup.string().required("Please enter the aim."),
  baselineMagnitude: Yup.string().required(
    "Please enter the baseline magnitude of the problem."
  ),
  targetMagnitude: Yup.string().required(
    "Please enter the target magnitude of the problem."
  ),
  baselineMagnitudeUnitOfMeasure: Yup.string().required(
    "Please enter the baseline unit of measure."
  ),
  targetMagnitudeUnitOfMeasure: Yup.string().required(
    "Please enter the target unit of measure."
  ),
  from: Yup.string().required("Required!"),
  to: Yup.string().required("Required!"),
});

export const aimStatement = {
  validateOnChange: true,
  validateOnBlur: true,
  initialValues: {
    qitName: "",
    aim: "",
    baselineMagnitude: "",
    baselineMagnitudeUnitOfMeasure: "",
    targetMagnitude: "",
    targetMagnitudeUnitOfMeasure: "",
    from: "",
    to: "",
    aimStatement: "",
  },
  validationSchema: AimStatementSchema,
};

const RootCauseAnalysisSchema = Yup.object().shape({
  effect: Yup.string().required("Effect is required"),
  causes: Yup.array()
    .of(
      Yup.object().shape({
        key: Yup.string().required("Key is required"),
        category: Yup.string().required("Category is required"),
        primaryCauses: Yup.array()
          .of(
            Yup.object().shape({
              primary: Yup.string().required("Primary cause is required"),
              secondaryCauses: Yup.array().of(
                Yup.string().required("Secondary cause is required")
              ),
              isSubCauseAdded: Yup.boolean().required(
                "isSubCauseAdded is required"
              ),
            })
          )
          .required("Primary causes are required"),
      })
    )
    .required("Causes are required"),
});

export interface FishboneData {
  effect: string;
  causes: {
    key: string;
    category: string;
    primaryCauses: {
      primary: string;
      secondaryCauses: any[];
      isSubCauseAdded: boolean;
    }[];
  }[];
}
export const rootCauseAnalysis = {
  validateOnChange: true,
  validateOnBlur: true,
  initialValues: {
    effect: "",
    causes: [
      {
        key: "",
        category: "",
        primaryCauses: [
          {
            primary: "",
            secondaryCauses: [],
            isSubCauseAdded: false,
          },
        ],
      },
    ],
  },
  validationSchema: RootCauseAnalysisSchema,
};
